import { useMediaQuery } from './use-media-query'
import { useUtility } from './use-utility'

export const useIsMobile = () => {
  const { breakpoints } = useUtility()
  return useMediaQuery(breakpoints.down('md'))
}
